import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BottomNavFavoriteIcon = ({ primaryColor = '#414042', size, style, secondaryColor, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 17.15 16.38' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path
            fill={primaryColor}
            d='M16.88,7.02l-4,3.36,1.26,5.07c.08.3-.04.61-.29.8-.25.18-.59.19-.85.03l-4.43-2.77-4.43,2.77c-.12.07-.26.11-.4.12-.16,0-.32-.05-.45-.15-.25-.18-.36-.5-.29-.8l1.26-5.07L.27,7.02c-.32-.27-.36-.75-.09-1.07.13-.16.32-.25.53-.27l5.21-.36L7.87.47c.15-.39.6-.57.98-.42.19.08.34.23.42.42l1.96,4.84,5.21.37c.42.03.73.39.7.81-.01.21-.11.39-.27.53h0Z'
        />
    </SvgIcon>
);

export default BottomNavFavoriteIcon;
